import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { MarketOrderClient } from 'src/WebApiController';

export const COUPON_BALANCE_QUERY_KEY = 'MarketOrderClient.getCouponBalance';

/**
 * Fetches the coupon balance for the active seller account.
 * The backend caches the result for ~5 minutes.
 */
export function useGetCouponBalance() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();

  const shouldQuery = !!activeAccountWebClientConfig?.activeAccountId;

  return useQuery({
    queryKey: [
      COUPON_BALANCE_QUERY_KEY,
      activeAccountWebClientConfig?.activeAccountId,
    ],
    async queryFn({ signal }) {
      if (!shouldQuery) return null;

      try {
        const client = new MarketOrderClient(activeAccountWebClientConfig);
        return await client.getCouponBalance(signal);
      } catch (err: unknown) {
        trackError('MarketOrderClient.getCouponBalance', err as ErrorTypes, {});
        throw err;
      }
    },
    enabled: shouldQuery,
    refetchOnWindowFocus: false,
    // ~5 minute stale time to align with the backend cache
    staleTime: 5 * 60 * 1000,
  });
}
